var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpContentType, HttpHeaderType, handleResponse, EnvironmentService, getRandomUuidV4 } from "../../common";
import { QUESTIONNAIRE_EVALUATION_FAILURE } from '../actions';
import { QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL } from '../constants';
export class QuestionnaireEvaluationService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
        this.apiUrl = `${EnvironmentService.getEnvironment().connectServicesUrl}`;
    }
    /*
    Service call for Get Questionnaire Evaluation
    */
    getAllQuestionaireEvaluation(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiUrl}v1/apd/questionnaire/question/companies/${requestData.coCode}/QuestionnaireEvaluations/${requestData.evalId}/Questions?evaluate=${requestData.shouldIncludeEvalution}`;
            let request = new Request(url, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                })
            });
            return yield this.fetchWrapper(request)
                .then(response => {
                return handleResponse(response);
            })
                .catch(() => {
                return Promise.reject(QUESTIONNAIRE_EVALUATION_FAILURE);
            });
        });
    }
    /*
    Service call for Save Questionnaire Evaluation
    */
    questionnaireEvaluationSaveQuestionnaire(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiUrl}v1/apd/questionnaire/question/companies/${requestData.coCode}/QuestionnaireEvaluations/${requestData.evalId}?CacheOnly=${requestData.isCacheOnly}&version=${!requestData.isCacheOnly}&evaluate=${requestData.shouldIncludeEvalution}`;
            const request = new Request(url, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                }),
                body: JSON.stringify(requestData.questionsData)
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
}
//# sourceMappingURL=QuestionnaireEvaluationQuestionsService.js.map